(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["threads-carry-deck"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('threads-carry-deck')) {
    customElements.define('threads-carry-deck', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.active = 0;
        this.paused = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.cards = [...this.querySelectorAll('[data-deck-card]')];
        this.choices = [...this.querySelectorAll('[data-deck-choice]')];
        this.addEventListener('click', (event) => {
          const choice = event.target.closest('[data-deck-choice]');
          if (choice) this.show(Number(choice.dataset.deckChoice));
          const pause = event.target.closest('[data-deck-pause]');
          if (pause) {
            this.paused = !this.paused;
            pause.setAttribute('aria-pressed', String(this.paused));
            pause.setAttribute('aria-label', this.paused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel);
            pause.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
          }
        });
        this.addEventListener('focusin', (event) => {
          const card = event.target.closest('[data-deck-card]');
          if (card) this.show(Number(card.dataset.deckCard));
        });
        this.timer = setInterval(() => {
          if (!this.paused && !this.motion.matches && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.show((this.active + 1) % this.cards.length);
        }, 6500);
      }
      show(index) {
        this.active = index;
        this.cards.forEach((card, i) => card.dataset.position = String((i - index + this.cards.length) % this.cards.length));
        this.choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === index)));
      }
      disconnectedCallback() { clearInterval(this.timer); this.ready = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["threads-product-loop"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-loop-pause]');
    if (!button) return;
    const section = button.closest('[data-threads-product-loop]');
    const paused = section.dataset.paused !== 'true';
    section.dataset.paused = String(paused);
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
    button.querySelector('[data-loop-symbol]').textContent = paused ? '▷' : 'Ⅱ';
    if (!paused) button.blur();
  });

  } catch(e) { console.error(e); }
})();
})();
